import React, { useState, useEffect } from 'react';
import './AmbientBackground.css';

// --- 1. THE 5 PATTERNS ---
// I've generated abstract SVG representations of your requested themes.
// For highly detailed dragons or murals, you can swap these for <img src="/images/dragon.png" /> later!

const WavyLines = () => (
  <svg viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="0.5">
    <path d="M0 50 Q 25 20, 50 50 T 100 50 M0 60 Q 25 30, 50 60 T 100 60 M0 70 Q 25 40, 50 70 T 100 70" />
  </svg>
);

const FloralPattern = () => (
  <svg viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="0.5">
    <circle cx="50" cy="50" r="40" />
    <path d="M50 10 Q 90 50, 50 90 Q 10 50, 50 10 M10 50 Q 50 10, 90 50 Q 50 90, 10 50" />
  </svg>
);

const AfricanTraditional = () => (
  <svg viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="0.5">
    <polygon points="0,100 50,0 100,100" />
    <polygon points="25,100 50,50 75,100" />
    <polygon points="10,100 50,20 90,100" />
  </svg>
);

const ChineseDragonScales = () => (
  <svg viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="0.5">
    <path d="M0 20 A 20 20 0 0 0 40 20 A 20 20 0 0 0 80 20 A 20 20 0 0 0 120 20" />
    <path d="M-20 40 A 20 20 0 0 0 20 40 A 20 20 0 0 0 60 40 A 20 20 0 0 0 100 40" />
    <path d="M0 60 A 20 20 0 0 0 40 60 A 20 20 0 0 0 80 60 A 20 20 0 0 0 120 60" />
  </svg>
);

const MuralSwirls = () => (
  <svg viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="0.5">
    <path d="M10 90 C 10 10, 90 10, 90 90 C 50 90, 50 50, 90 50" />
    <circle cx="90" cy="50" r="5" />
  </svg>
);

const patterns = [
  <WavyLines key="1" />,
  <FloralPattern key="2" />,
  <AfricanTraditional key="3" />,
  <ChineseDragonScales key="4" />,
  <MuralSwirls key="5" />
];

// --- 2. THE POSITIONS ---
const positions = [
  { bottom: '-10%', left: '-10%', top: 'auto', right: 'auto' }, // Bottom Left
  { top: '-10%', right: '-10%', bottom: 'auto', left: 'auto' }, // Top Right
  { bottom: '10%', left: '10%', top: 'auto', right: 'auto' },   // Left Center
];

export default function AmbientBackground() {
  const [currentIndex, setCurrentIndex] = useState({ pattern: 0, position: 0 });

  useEffect(() => {
    const calculatePattern = () => {
      // 6 hours in milliseconds
      const sixHoursMs = 6 * 60 * 60 * 1000; 
      
      // Get the current time block since Jan 1 1970
      const currentBlock = Math.floor(Date.now() / sixHoursMs);

      // Use the block number to pick a consistent pattern and position
      setCurrentIndex({
        pattern: currentBlock % patterns.length,
        position: currentBlock % positions.length,
      });
    };

    // Calculate immediately on load
    calculatePattern();

    // Check every minute just in case they leave the tab open across a 6-hour mark
    const interval = setInterval(calculatePattern, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="ambient-wrapper">
      <div 
        className="ambient-graphic"
        style={{
          ...positions[currentIndex.position],
        }}
      >
        {patterns[currentIndex.pattern]}
      </div>
    </div>
  );
}